/**
 * 用户类型
 * @type {{keyMap: {admin: number, user: number}, nameMap: {0: string, 1: string}}}
 */
export const userType = {
    keyMap: {
        user: 0,
        admin: 1
    },
    nameMap: {
        0: '普通用户',
        1: '管理员'
    }
}

/**
 * 时间格式化类型
 */
export const timeFormat = {
    dateMinute: 'YYYY-MM-DD HH:mm',
    dateTime: 'YYYY-MM-DD HH:mm:ss',
    date: 'YYYY-MM-DD',
    dateYear: 'YYYY',
    dateMonth: 'YYYY-MM',
    dateWeek: 'dddd',
    time: 'HH:mm:ss',
    dateTimeNoSeparator: 'YYYYMMDDHHmmss',
    dateNoSeparator: 'YYYYMMDD'
}

/**
 * redux异步action类型映射
 * @type {{success: string, pending: string, error: string}}
 */
export const reduxAsyncCaseTypeMap = {
    pending: 'pending',
    success: 'fulfilled',
    error: 'rejected'
}

/**
 * 商品上下架状态
 * @type {{"0": string, "1": string}}
 */
export const putAwayStatusMap = {
    '0': '下架',
    '1': '上架'
}

export const displayStatusMap = {
    '0': 'C端展示',
    '1': 'C端不展示,可购买',
    '2': 'C端不展示,不可购买'
}

export const userStatusMap = {
    '': '全部',
    '0': '正常',
    '1': '冻结'
}

export const educationMap = {
    '1': '本科',
    '2': '硕士',
    '3': '博士',
    '4': '大专'
}

export const policyAcceptStatusMap = {
    '0': '不接受',
    '1': '接受'
}

export const giftFlagMap = {
    '0': '否',
    '1': '是'
}

export const isDefaultMap = {
    '0': '否',
    '1': '是'
}

export const payStatusMap = {
    '0': '待付款',
    '1': '部分付款',
    '2': '已付款'
}

export const serviceWorkStatusMap = {
    '': '全部',
    '0': '离线',
    '1': '工作',
    '2': '挂起'
}

export const serviceWorkStatusArr = ['0', '1', '2']

export const paymentStatusArr = ['0', '1']

export const refundStatusMap = {
    '': '全部',
    '0': '退款处理中',
    '1': '退款拒绝',
    '2': '退款成功',
    '3': '退款关闭',
    '4': '退款失败'
}

export const exchangeStateMap = {
    '0': '换货待卖家处理',
    '1': '拒绝换货-初审驳回',
    '2': '卖家同意换货，待买家退货',
    '3': '买家已退货，待卖家收货',
    '4': '换货成功',
    '5': '换货关闭-买家撤销申请',
    '6': '换货关闭-超时未提交退货信息',
    '7': '拒绝换货-原商品已退回'
}

export const serviceOfflineMessageStatusMap = {
    '0': '未处理',
    '1': '已处理'
}

export const shopTypeCode = ['Basic', 'Elite']

export const shopTypeMap = {
    'Basic': '基础版',
    'Elite': '精英版'
}

// 普通客服禁止勾选这些模块
export const disabledModules = [
    'servicio.setting',
    'manage.manage',
    'manage.shop',
    'manage.group',
    'manage.user'
]

export const shopTypeNoModuleMap = {
    'Basic': ['customer.customer', 'goods.goods', 'order.order'],
    'Elite': []
}

export const messageTypeMap = {
    '0': '已下单',
    '1': '已付款',
    '2': '已退款'
}

export const messageIdType = {
    '0': '订单号',
    '1': '订单号',
    '2': '退款号'
}

export const taskStatusArr = ['', '1', '2']

export const taskStatusMap = {
    '': '全部',
    '0': '待分配',
    '1': '待处理',
    '2': '已处理'
}

export const taskStatusColorMap = {
    '1': 'red',
    '2': 'green'
}

export const qaStatusMap = {
    'true': '启用',
    'false': '禁用'
}

export const qaTypeMap = {
    '1': '文字',
    '2': '图片',
    '3': '图文',
    '4': '超链接'
}

export const ROBOT_INTERACTIVE_MAX_LEN = 8

export const callStatusMap = {
    1: '人工接听',
    2: '人工未接听',
    3: '系统应答',
    4: '系统未应答',
    5: '客户已接听',
    6: '客户未接听',
    7: '座席未接听',
    8: '双方接听',
    9: '客户速挂'
}

export const callSatisfaction = {
    1: '非常满意',
    2: '一般',
    3: '不满意'
}

// 电话供应商
export const telSupplier = {
    0: '无供应商',
    1: '天润',
    2: '联通',
    3: '电信'
}

export const logisticsCompany = [
    '顺丰',
    '中通',
    '圆通',
    '申通',
    '韵达',
    '京东快递',
    '百世快运',
    '极兔',
    '德邦'
]

/**
 * 允许退货退款的状态
 * @type {number[]}
 */
export const canReturnGoodsForRefundStatus = [2, 3, 5]

export const orderStatusMap = {
    '0': '待付款',
    '1': '待发货',
    '2': '待收货',
    '3': '交易成功',
    '4': '交易关闭',
    '5': '待取货',
    '6': '待审核',
    '7': '审核驳回'
}

export const timeOutReplyType = {
    Send: 0, // 发送提示语
    Transfer: 1 // 转接给他人
}
